import Carousel from 'react-multi-carousel'
import { useState, useEffect } from 'react'
import 'react-multi-carousel/lib/styles.css'
import ProductBox from './ProductBox'
import classes from './FavoriteProducts.module.css'

const responsive = {
  veryWideScreen: {
    breakpoint: { max: 4800, min: 2100 },
    items: 6,
    slidesToSlide: 5,
    
  },
  wideScreen: {
    breakpoint: { max: 2100, min: 1360 },
    items: 4,
    slidesToSlide: 3,
  },
  desktop: {
    breakpoint: { max: 1360, min: 1199 },
    items: 3,
    slidesToSlide: 2,
  },
  smallDesktop: {
    breakpoint: { max: 1199, min: 1024 },
    items: 3,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
}

const products = [
  {
    id: 1,
    image: 'img/products/25-euro-amazon-gutschein.svg',
    link: '/produkt/25-euro-amazon-gutschein',
    name: 'Amazon 25 Euro',
  },
  {
    id: 2,
    image: 'img/products/paysafecard-10-euro.svg',
    link: '/produkt/paysafe-10-euro',
    name: 'Paysafe 10 Euro',
  },
  {
    id: 3,
    image: 'img/products/google-play-50-euro.svg',
    link: '/produkt/google-play-50-euro',
    name: 'Google Play 50 Euro',
  },
  {
    id: 4,
    image: 'img/products/paysafecard-50-euro.svg',
    link: '/produkt/paysafe-50-euro',
    name: 'Paysafe 50 Euro',
  },
  {
    id: 5,
    image: 'img/products/xbox-25-euro.svg',
    link: '/produkt/xbox-25-euro',
    name: 'Xbox 25 Euro',
  },
  {
    id: 6,
    image: 'img/products/zalando-10-euro.svg',
    link: '/produkt/zalando-10-euro',
    name: 'Zalando 10 Euro',
  },
  {
    id: 7,
    image: 'img/products/steam-50-euro.svg',
    link: '/produkt/steam-50-euro.svg',
    name: 'Steam 50 Euro',
  },
  {
    id: 8,
    image: 'img/products/spotify-30-euro.svg',
    link: '/produkt/spotify-30-euro.svg',
    name: 'Spotify 30 Euro',
  },
  {
    id: 9,
    image: 'img/products/nintendo-15-euro.svg',
    link: '/produkt/nintendo-15-euro',
    name: 'Nintendo 15 Euro',
  },
  {
    id: 10,
    image: 'img/products/paysafecard-20-euro.svg',
    link: '/produkt/paysafe-20-euro',
    name: 'Paysafe 20 Euro',
  },
  {
    id: 11,
    image: 'img/products/25-euro-amazon-gutschein.svg',
    link: '/produkt/25-euro-amazon-gutschein',
    name: 'Amazon 25 Euro',
  },
  {
    id: 12,
    image: 'img/products/paysafecard-10-euro.svg',
    link: '/produkt/paysafe-10-euro',
    name: 'Paysafe 10 Euro',
  },
  {
    id: 13,
    image: 'img/products/google-play-50-euro.svg',
    link: '/produkt/google-play-50-euro',
    name: 'Google Play 50 Euro',
  },
  {
    id: 14,
    image: 'img/products/paysafecard-50-euro.svg',
    link: '/produkt/paysafe-50-euro',
    name: 'Paysafe 50 Euro',
  },
  {
    id: 15,
    image: 'img/products/xbox-25-euro.svg',
    link: '/produkt/xbox-25-euro',
    name: 'Xbox 25 Euro',
  },
  {
    id: 16,
    image: 'img/products/zalando-10-euro.svg',
    link: '/produkt/zalando-10-euro',
    name: 'Zalando 10 Euro',
  },
  {
    id: 17,
    image: 'img/products/steam-50-euro.svg',
    link: '/produkt/steam-50-euro.svg',
    name: 'Steam 50 Euro',
  },
  {
    id: 18,
    image: 'img/products/spotify-30-euro.svg',
    link: '/produkt/spotify-30-euro.svg',
    name: 'Spotify 30 Euro',
  },
  {
    id: 19,
    image: 'img/products/nintendo-15-euro.svg',
    link: '/produkt/nintendo-15-euro',
    name: 'Nintendo 15 Euro',
  },
  {
    id: 20,
    image: 'img/products/paysafecard-20-euro.svg',
    link: '/produkt/paysafe-20-euro',
    name: 'Paysafe 20 Euro',
  },
]
const productsScreen = [
  {
    id: 1,
    image: 'img/products/25-euro-amazon-gutschein.svg',
    link: '/produkt/25-euro-amazon-gutschein',
    name: 'Amazon 25 Euro',
  },
  {
    id: 2,
    image: 'img/products/paysafecard-10-euro.svg',
    link: '/produkt/paysafe-10-euro',
    name: 'Paysafe 10 Euro',
  },
  {
    id: 3,
    image: 'img/products/google-play-50-euro.svg',
    link: '/produkt/google-play-50-euro',
    name: 'Google Play 50 Euro',
  },
  {
    id: 4,
    image: 'img/products/paysafecard-50-euro.svg',
    link: '/produkt/paysafe-50-euro',
    name: 'Paysafe 50 Euro',
  },
  {
    id: 5,
    image: 'img/products/xbox-25-euro.svg',
    link: '/produkt/xbox-25-euro',
    name: 'Xbox 25 Euro',
  },
  {
    id: 6,
    image: 'img/products/paysafecard-20-euro.svg',
    link: '/produkt/paysafe-20-euro',
    name: 'Paysafe 20 Euro',
  },
]

export default function FavoriteProducts() {
  const [isCarouselMode, setIsCarouselMode] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth
      if (screenWidth <= 1995) {
        setIsCarouselMode(true) // Enable centerMode for wideScreen
      } else {
        setIsCarouselMode(false) // Disable centerMode for other breakpoints
      }
    }

    handleResize() // Set initial value
    window.addEventListener('resize', handleResize) // Listen for screen size changes

    return () => {
      window.removeEventListener('resize', handleResize) // Cleanup on unmount
    }
  }, [])

  return (
    <>
    {isCarouselMode ? (
      <Carousel
      responsive={responsive}
      infinite={true}
      arrows={true}
      swipeable={true}
      draggable={true}
      keyBoardControl={true}
      customTransition='transform 300ms ease-in-out'
      transitionDuration={500}
      containerClass={classes.carouselContainer}
      removeArrowOnDeviceType={['smallDesktop', 'tablet', 'mobile']}
      centerMode={true}
    >
      {products.map((product) => (
        <ProductBox
          key={product.id}
          image={product.image}
          link={product.link}
          alt={product.name}
        />
      ))}
    </Carousel>
    ) : (
      <div
      className={`d-flex justify-content-center align-items-center ${classes.productGrid}`}>
        {productsScreen.map((product) => (
          <ProductBox
            key={product.id}
            image={product.image}
            link={product.link}
            alt={product.name}
          />
        ))}
      </div>
    )}
      </>
  )
}
